import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgxSpinnerService } from "ngx-spinner";
import { VeiculoSensor } from "src/app/models/VeiculoSensor.model";
import { VwSensor } from "src/app/models/VwSensor.model";
import { EventEmitterSensorService } from "src/app/services/event-emitter-sensor.service";
import { ApiBaseService } from "src/app/services/migrate/api.base.service";
import {
  STORAGE_KEY_CURRENT_USER,
  STORAGE_KEY_ID_PERFIL,
} from "src/app/storageCore/constStorageKeys";
import storageX from "src/app/storageCore/storageX";
import Swal from "sweetalert2";
import { appendSensorToCombo, findVeiculoSensorByPosicaoId, findIncompleteSensorRows, alertIncompleteTpmsRows } from "src/app/utils/veiculo-sensor.util";

@Component({
  selector: "app-axle-four-dual",
  templateUrl: "./axle-four-dual.component.html",
  styleUrls: ["./axle-four-dual.component.scss"],
})
export class AxleFourDualComponent implements OnInit {
  @Input() veiculoSensores: any;
  @Input() sensoresDisponiveis: any;
  @Input() veiculoId: number;

  @Output() atualizarSensores = new EventEmitter<void>();

  public sensorFourIntLeftSelect: any = [];
  public sensorFourIntRightSelect: any = [];

  public sensorFourExtLeftSelect: any = [];
  public sensorFourExtRightSelect: any = [];

  public sensorFourIntRightCombo: any = [];
  public sensorFourIntLeftCombo: any = [];

  public sensorFourExtRightCombo: any = [];
  public sensorFourExtLeftCombo: any = [];

  public axisFourDoubleLeftIntForm: FormGroup;
  public axisFourDoubleLeftExtForm: FormGroup;
  public axisFourDoubleRightIntForm: FormGroup;
  public axisFourDoubleRightExtForm: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    private serviceApiBase: ApiBaseService,
    private componentResetService: EventEmitterSensorService
  ) {}

  ngOnInit(): void {
    this.componentResetService.reiniciarComponentes$.subscribe(async (a) => {
      this.sensoresDisponiveis = null;
      this.veiculoSensores = null;
      this.sensorFourIntRightCombo = [];
      this.sensorFourIntLeftCombo = [];
      this.sensorFourExtRightCombo = [];
      this.sensorFourExtLeftCombo = [];

      const perfil = storageX.whereKeyIs(STORAGE_KEY_ID_PERFIL).get();

      const eixo = await this.serviceApiBase.get<any>({
        url: new VeiculoSensor()["nomeConsultaApiBase"] + this.veiculoId,
      });

      this.veiculoSensores = eixo["content"] ?? [];

      const sensor = await this.serviceApiBase.get<any>({
        url:
          new VwSensor()["nomeConsultaApiBaseSensor"] +
          this.veiculoId +
          "/perfil/" +
          perfil,
      });

      this.sensoresDisponiveis = sensor;

      if (this.sensoresDisponiveis.length > 0) {
        this.sensoresDisponiveis.forEach((element) => {
          this.sensorFourIntRightCombo.push(element);
          this.sensorFourIntLeftCombo.push(element);
          this.sensorFourExtRightCombo.push(element);
          this.sensorFourExtLeftCombo.push(element);
        });
      }

      this.loadSensor();
    });
    this.axisFourDoubleLeftIntForm = this.formBuilder.group(
      {
        id: [""],
        pneu: [null],
        cdPosicaoPneu: [""],
        cdSensor: [""],
        nrPressaoMinima: ["", Validators.required],
        nrPressaoMaxima: ["", Validators.required],
        nrTemperaturaMaxima: ["", Validators.required],
      },

      { updateOn: "blur" }
    );

    this.axisFourDoubleLeftExtForm = this.formBuilder.group(
      {
        id: [""],
        pneu: [null],
        cdPosicaoPneu: [""],
        cdSensor: [""],
        nrPressaoMinima: ["", Validators.required],
        nrPressaoMaxima: ["", Validators.required],
        nrTemperaturaMaxima: ["", Validators.required],
      },

      { updateOn: "blur" }
    );

    this.axisFourDoubleRightIntForm = this.formBuilder.group(
      {
        id: [""],
        pneu: [null],
        cdPosicaoPneu: [""],
        cdSensor: [""],
        nrPressaoMinima: ["", Validators.required],
        nrPressaoMaxima: ["", Validators.required],
        nrTemperaturaMaxima: ["", Validators.required],
      },

      { updateOn: "blur" }
    );

    this.axisFourDoubleRightExtForm = this.formBuilder.group(
      {
        id: [""],
        pneu: [null],
        cdPosicaoPneu: [""],
        cdSensor: [""],
        nrPressaoMinima: ["", Validators.required],
        nrPressaoMaxima: ["", Validators.required],
        nrTemperaturaMaxima: ["", Validators.required],
      },

      { updateOn: "blur" }
    );

    if (this.sensoresDisponiveis.length > 0) {
      this.sensoresDisponiveis.forEach((element) => {
        this.sensorFourExtRightCombo.push(element);
        this.sensorFourExtLeftCombo.push(element);
        this.sensorFourIntRightCombo.push(element);
        this.sensorFourIntLeftCombo.push(element);
      });
    }

    this.loadSensor();
  }

  public async loadSensor(): Promise<void> {
    try {
      this.spinner.show();
      this.axisFourDoubleLeftIntForm.controls["cdPosicaoPneu"].setValue(
        "EIXO 4 ESQ INT"
      );
      this.axisFourDoubleLeftExtForm.controls["cdPosicaoPneu"].setValue(
        "EIXO 4 ESQ EXT"
      );

      this.axisFourDoubleRightIntForm.controls["cdPosicaoPneu"].setValue(
        "EIXO 4 DIR INT"
      );
      this.axisFourDoubleRightExtForm.controls["cdPosicaoPneu"].setValue(
        "EIXO 4 DIR EXT"
      );

      if (this.veiculoSensores.length > 0) {
        const eixo4DireitoExt = findVeiculoSensorByPosicaoId(
          this.veiculoSensores,
          10
        );
        const eixo4EsquerdoExt = findVeiculoSensorByPosicaoId(
          this.veiculoSensores,
          9
        );
        const eixo4DireitoInt = findVeiculoSensorByPosicaoId(
          this.veiculoSensores,
          26
        );
        const eixo4EsquerdoInt = findVeiculoSensorByPosicaoId(
          this.veiculoSensores,
          25
        );

        // EIXO 4 DIREITO EXTERNO
        if (eixo4DireitoExt != null) {
          this.axisFourDoubleRightExtForm.controls["id"].setValue(
            eixo4DireitoExt.id
          );

          if (eixo4DireitoExt.sensor != null) {
            appendSensorToCombo(this.sensorFourExtRightCombo, eixo4DireitoExt.sensor);
            this.sensorFourExtRightSelect = eixo4DireitoExt.sensor.id;
          }

          if (eixo4DireitoExt.pneu != null) {
            this.axisFourDoubleRightExtForm.controls["pneu"].setValue(
              eixo4DireitoExt.pneu.numeroFogo
            );
          }

          this.axisFourDoubleRightExtForm.controls["nrPressaoMinima"].setValue(
            eixo4DireitoExt.nrPressaoMinima
          );

          this.axisFourDoubleRightExtForm.controls["nrPressaoMaxima"].setValue(
            eixo4DireitoExt.nrPressaoMaxima
          );

          this.axisFourDoubleRightExtForm.controls[
            "nrTemperaturaMaxima"
          ].setValue(eixo4DireitoExt.nrTemperaturaMaxima);
        }

        // EIXO 4 ESQUERDO EXTERNO
        if (eixo4EsquerdoExt != null) {
          this.axisFourDoubleLeftExtForm.controls["id"].setValue(
            eixo4EsquerdoExt.id
          );

          if (eixo4EsquerdoExt.sensor != null) {
            appendSensorToCombo(this.sensorFourExtLeftCombo, eixo4EsquerdoExt.sensor);
            this.sensorFourExtLeftSelect = eixo4EsquerdoExt.sensor.id;
          }

          if (eixo4EsquerdoExt.pneu != null) {
            this.axisFourDoubleLeftExtForm.controls["pneu"].setValue(
              eixo4EsquerdoExt.pneu.numeroFogo
            );
          }

          this.axisFourDoubleLeftExtForm.controls["nrPressaoMinima"].setValue(
            eixo4EsquerdoExt.nrPressaoMinima
          );

          this.axisFourDoubleLeftExtForm.controls["nrPressaoMaxima"].setValue(
            eixo4EsquerdoExt.nrPressaoMaxima
          );

          this.axisFourDoubleLeftExtForm.controls[
            "nrTemperaturaMaxima"
          ].setValue(eixo4EsquerdoExt.nrTemperaturaMaxima);
        }

        // EIXO 4 DIREITO INTERNO
        if (eixo4DireitoInt != null) {
          this.axisFourDoubleRightIntForm.controls["id"].setValue(
            eixo4DireitoInt.id
          );

          if (eixo4DireitoInt.sensor != null) {
            appendSensorToCombo(this.sensorFourIntRightCombo, eixo4DireitoInt.sensor);
            this.sensorFourIntRightSelect = eixo4DireitoInt.sensor.id;
          }

          if (eixo4DireitoInt.pneu != null) {
            this.axisFourDoubleRightIntForm.controls["pneu"].setValue(
              eixo4DireitoInt.pneu.numeroFogo
            );
          }

          this.axisFourDoubleRightIntForm.controls["nrPressaoMinima"].setValue(
            eixo4DireitoInt.nrPressaoMinima
          );

          this.axisFourDoubleRightIntForm.controls["nrPressaoMaxima"].setValue(
            eixo4DireitoInt.nrPressaoMaxima
          );

          this.axisFourDoubleRightIntForm.controls[
            "nrTemperaturaMaxima"
          ].setValue(eixo4DireitoInt.nrTemperaturaMaxima);
        }

        // EIXO 4 ESQUERDO INTERNO
        if (eixo4EsquerdoInt != null) {
          this.axisFourDoubleLeftIntForm.controls["id"].setValue(
            eixo4EsquerdoInt.id
          );

          if (eixo4EsquerdoInt.sensor != null) {
            appendSensorToCombo(this.sensorFourIntLeftCombo, eixo4EsquerdoInt.sensor);
            this.sensorFourIntLeftSelect = eixo4EsquerdoInt.sensor.id;
          }

          if (eixo4EsquerdoInt.pneu != null) {
            this.axisFourDoubleLeftIntForm.controls["pneu"].setValue(
              eixo4EsquerdoInt.pneu.numeroFogo
            );
          }

          this.axisFourDoubleLeftIntForm.controls["nrPressaoMinima"].setValue(
            eixo4EsquerdoInt.nrPressaoMinima
          );

          this.axisFourDoubleLeftIntForm.controls["nrPressaoMaxima"].setValue(
            eixo4EsquerdoInt.nrPressaoMaxima
          );

          this.axisFourDoubleLeftIntForm.controls[
            "nrTemperaturaMaxima"
          ].setValue(eixo4EsquerdoInt.nrTemperaturaMaxima);
        }
      }

      this.spinner.hide();
    } catch (error) {
      this.spinner.hide();
      console.error("loadVeiculo() error", error);
    }
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  public async submitFormDelete(form: FormGroup): Promise<void> {
    this.spinner.show();
    try {
      const values = form.value;
      var post;

      post = {
        veiculo: {
          id: this.veiculoId,
        },
        nrPressaoMinima: values.nrPressaoMinima,
        nrPressaoMaxima: values.nrPressaoMaxima,
        nrTemperaturaMaxima: values.nrTemperaturaMaxima,
        sensor: {
          id: values.cdSensor,
        },
        pneu: null,
        idUsuario: storageX.whereKeyIs(STORAGE_KEY_CURRENT_USER).get()?.id,
      };

      console.log(post);

      const result = await this.serviceApiBase.put<VeiculoSensor>(
        values.id,
        new VeiculoSensor()["nomeConsultaApiBaseRemove"],
        post
      );

      form.get("cdSensor").setValue("");
      form.get("id").setValue("");

      this.spinner.hide();

      this.handleDelete();

      this.atualizarSensores.emit();
    } catch (error) {
      this.spinner.hide();
      //this.errorMessage = error.message;
      throw new EvalError(error);
    }
  }

  public async submitFormDeleteAll(): Promise<void> {
    this.spinner.show();
    try {
      var estepeArray: any = [];
      var posicoesPneusList: any = [];

      estepeArray.push(this.axisFourDoubleRightIntForm.value);
      estepeArray.push(this.axisFourDoubleLeftIntForm.value);
      estepeArray.push(this.axisFourDoubleRightExtForm.value);
      estepeArray.push(this.axisFourDoubleLeftExtForm.value);

      if (estepeArray.length > 0) {
        estepeArray.forEach((element) => {
          var posicaoPneuResquest = {
            cdPosicaoPneu: element.cdPosicaoPneu,
          };
          posicoesPneusList.push(posicaoPneuResquest);
        });
      }

      var post = {
        veiculoSensores: posicoesPneusList,
      };

      const result = await this.serviceApiBase.put<VeiculoSensor>(
        this.veiculoId,
        new VeiculoSensor()["nomeConsultaApiBaseRemoveAll"],
        post
      );

      this.axisFourDoubleRightIntForm.get("cdSensor").setValue("");
      this.axisFourDoubleRightIntForm.get("id").setValue("");
      this.axisFourDoubleLeftIntForm.get("cdSensor").setValue("");
      this.axisFourDoubleLeftIntForm.get("id").setValue("");
      this.axisFourDoubleRightExtForm.get("cdSensor").setValue("");
      this.axisFourDoubleRightExtForm.get("id").setValue("");
      this.axisFourDoubleLeftExtForm.get("cdSensor").setValue("");
      this.axisFourDoubleLeftExtForm.get("id").setValue("");

      this.spinner.hide();

      this.handleDeleteAll();

      this.atualizarSensores.emit();
    } catch (error) {
      this.spinner.hide();
      throw new EvalError(error);
    }
  }

  public async submitFormAddAll(): Promise<void> {
    var estepeArray: any = [];

      estepeArray.push(this.axisFourDoubleRightIntForm.value);
      estepeArray.push(this.axisFourDoubleLeftIntForm.value);
      estepeArray.push(this.axisFourDoubleRightExtForm.value);
      estepeArray.push(this.axisFourDoubleLeftExtForm.value);

    const posicoesIncompletas = findIncompleteSensorRows(estepeArray);
    if (posicoesIncompletas.length > 0) {
      await alertIncompleteTpmsRows(posicoesIncompletas);
      return;
    }

    if (estepeArray.length > 0 && this.verificarDuplicados(estepeArray)) {
      this.handleItensDuplicados();
      return;
    }

    var posicoesPneusList: any = [];

    estepeArray.forEach((element) => {
      if (element.cdSensor != "") {
        var posicaoPneuResquest = {
          cdPosicaoPneu: element.cdPosicaoPneu,
          cdSensor: element.cdSensor,
          pneu: element.pneu,
          nrPressaoMinima: element.nrPressaoMinima,
          nrPressaoMaxima: element.nrPressaoMaxima,
          nrTemperaturaMaxima: element.nrTemperaturaMaxima,
          idPerfil: storageX.whereKeyIs(STORAGE_KEY_CURRENT_USER).get()?.id,
        };
        posicoesPneusList.push(posicaoPneuResquest);
      }
    });

    if (posicoesPneusList.length === 0) {
      return;
    }

    this.spinner.show();
    try {
      var post = {
        veiculoSensores: posicoesPneusList,
      };

      const result = await this.serviceApiBase.put<VeiculoSensor>(
        this.veiculoId,
        new VeiculoSensor()["nomeConsultaApiBaseAddAll"],
        post
      );

      this.spinner.hide();

      this.handleAddAll();

      this.atualizarSensores.emit();
    } catch (error) {
      this.spinner.hide();
      throw new EvalError(error);
    }
  }


  verificarDuplicados(axisOneArray: any[]): boolean {
    const seen = new Set();
    for (const item of axisOneArray) {
      if (seen.has(item.cdSensor)) {
        return true; // Retorna true se encontrar um valor duplicado
      } else {
        seen.add(item.cdSensor);
      }
    }
    return false; // Retorna false se não houver valores duplicados
  }

  public async handleItensDuplicados(): Promise<void> {
    Swal.fire({
      icon: "warning",
      title: "Sensores selecionados estão com duplicidade, por favor corrigir!",
      showCloseButton: false,
      reverseButtons: true,
      showConfirmButton: true,
      confirmButtonText: "OK",
      focusConfirm: false,
    });
  }

  public async handleAddAll(): Promise<void> {
    Swal.fire({
      icon: "success",
      title: "Sensores do EIXO 4 vinculados com sucesso",
      showCloseButton: false,
      reverseButtons: true,
      showConfirmButton: true,
      confirmButtonText: "OK",
      focusConfirm: false,
    });
  }

  public async handleDeleteAll(): Promise<void> {
    Swal.fire({
      icon: "success",
      title: "Sensores do EIXO 4 desvinculados com sucesso",
      showCloseButton: false,
      reverseButtons: true,
      showConfirmButton: true,
      confirmButtonText: "OK",
      focusConfirm: false,
    });
  }

  public async handleDelete(): Promise<void> {
    Swal.fire({
      icon: "success",
      title: "Sensor desvinculados com sucesso",
      showCloseButton: false,
      reverseButtons: true,
      showConfirmButton: true,
      confirmButtonText: "OK",
      focusConfirm: false,
    });
  }
}
